import { orgInfoSchema } from './orgInfo';
export const orgUserInviteSchema = {
    $id: 'urn:wisepipe-domain-authorize:OrgUserInvite',
    type: 'object',
    properties: {
        orgInfo: { $ref: orgInfoSchema.$id },
        userEmail: { type: 'string', minLength: 1 },
        inviterUserID: { type: 'string', format: 'uuid' },
        userID: { type: 'string', format: 'uuid' },
        cognitoUserID: { type: 'string' },
        roleID: { type: 'string', format: 'uuid' },
        supportUser: { type: 'boolean' },
        currentRoleID: { type: 'string', format: 'uuid' },
        createdAt: { type: 'string', format: 'date-time' },
        acceptedAt: { type: 'string', format: 'date-time' },
        rejectedAt: { type: 'string', format: 'date-time' }
    },
    required: ['orgInfo', 'userEmail', 'createdAt'],
    // make sure that it can't be both accepted and rejected at same time
    not: { required: ['acceptedAt', 'rejectedAt'] }
};
//# sourceMappingURL=orgUserInvite.js.map